import React, { useState } from "react";
import coffe from "../../assets/images/coffe.png";
import lilacpearls from "../../assets/images/lilacpearls.png";
import blogimage from "../../assets/images/Screenshot 2025-09-10 080723.png";
import shopeeBayImage from "../../assets/images/Screenshot 2025-11-24 153816.png";
import perplexityImage from "../../assets/images/Screenshot 2025-11-24 154654.png";
import dbAgentImage from "../../assets/images/Screenshot 2025-11-24 131535.png";
import aiProjectsData from "../../config/ai-project.json";
import webProjectsData from "../../config/web-project.json";

function Portfolio() {
  const [activeCategory, setActiveCategory] = useState("ai");

  const imageMap = {
    lilacpearls,
    blogmaster: shopeeBayImage,
    coffee: coffe,
    aiblog: blogimage,
    perplexity2: perplexityImage,
    dbagent: dbAgentImage,
  };

  const projects = [
    ...aiProjectsData.map((project) => ({
      ...project,
      category: "ai",
      image: imageMap[project.imageKey],
    })),
    ...webProjectsData.map((project) => ({
      ...project,
      category: "web",
      image: imageMap[project.imageKey],
    })),
  ];

  const filteredProjects = projects.filter(
    (project) => project.category === activeCategory
  );

  return (
    <section
      id="portfolio"
      className="min-h-screen bg-gradient-to-b from-[#0B1120] via-[#0F172A] to-[#1E293B] py-16"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
            My Projects
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            A showcase of some of my most recent work. Built with performance, scalability, and clean UI in mind.
          </p>
        </div>

        <div className="flex justify-center mb-10">
          <div className="inline-flex items-center rounded-full bg-[#020617]/80 border border-[#1E293B] p-1 shadow-lg shadow-blue-500/20">
            <button
              type="button"
              onClick={() => setActiveCategory("ai")}
              className={`px-5 py-2 text-sm md:text-base rounded-full transition-all duration-300 ${activeCategory === "ai"
                  ? "bg-gradient-to-r from-indigo-500 via-blue-500 to-cyan-400 text-white shadow-[0_0_15px_rgba(56,189,248,0.6)]"
                  : "text-gray-300 hover:text-white"
                }`}
              aria-pressed={activeCategory === "ai"}
            >
              AI Projects
            </button>
            <button
              type="button"
              onClick={() => setActiveCategory("web")}
              className={`ml-1 px-5 py-2 text-sm md:text-base rounded-full transition-all duration-300 ${activeCategory === "web"
                  ? "bg-gradient-to-r from-indigo-500 via-blue-500 to-cyan-400 text-white shadow-[0_0_15px_rgba(56,189,248,0.6)]"
                  : "text-gray-300 hover:text-white"
                }`}
              aria-pressed={activeCategory === "web"}
            >
              Web Dev Projects
            </button>
          </div>
        </div>

        <div className="space-y-10">
          {filteredProjects.map((project) => (
            <div key={project.id} className="relative max-w-5xl mx-auto group">
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/30 via-blue-500/20 to-cyan-400/30 opacity-0 group-hover:opacity-100 blur-3xl transition-opacity duration-500 pointer-events-none" />

              <div className="relative bg-[#020617]/80 backdrop-blur-md border border-[#334155]/80 rounded-3xl shadow-xl overflow-hidden transition-transform transform group-hover:scale-[1.01] group-hover:shadow-blue-500/40">
                <div className="flex flex-col lg:flex-row">
                  {/* Image side */}
                  <div className="relative w-full lg:w-6/12 px-3 py-4 sm:px-5 sm:py-6 flex items-center justify-center">
                    <div className="absolute -inset-6 bg-[radial-gradient(circle_at_top,_rgba(56,189,248,0.35),transparent_60%),radial-gradient(circle_at_bottom,_rgba(129,140,248,0.3),transparent_60%)] opacity-50 group-hover:opacity-80 blur-2xl transition-opacity duration-500 pointer-events-none" />

                    <div className="relative w-full max-w-xl mx-auto rounded-3xl overflow-hidden border border-slate-700/80 bg-black/95 shadow-[0_18px_45px_rgba(15,23,42,0.9)]">
                      <img
                        src={project.image}
                        alt={project.name}
                        className="w-full h-auto max-h-[24rem] md:max-h-[26rem] object-contain group-hover:scale-[1.03] transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                  </div>

                  {/* Content side */}
                  <div className="w-full lg:w-7/12 p-6 md:p-8 flex flex-col justify-between gap-4">
                    <div>
                      <p className="uppercase tracking-[0.25em] text-xs text-cyan-400 mb-2">
                        {project.category === "ai" ? "AI Project" : "Web Development"}
                      </p>
                      <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                        {project.name}
                      </h3>
                      <p className="text-gray-300 mb-2 md:mb-4">
                        {project.description}
                      </p>
                    </div>

                    <div className="flex flex-wrap gap-3 md:gap-4">
                      <a
                        href={project.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 px-4 py-2 border border-blue-400 text-blue-400 rounded-lg hover:bg-blue-500 hover:text-white transition-all duration-300 text-sm md:text-base"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                        </svg>
                        Code
                      </a>

                      <a
                        href={project.live}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-green-400 via-blue-500 to-purple-600 text-white rounded-lg hover:opacity-90 transition-all duration-300 text-sm md:text-base"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <line x1="2" y1="12" x2="22" y2="12"></line>
                          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                        </svg>
                        Live Demo
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
